import { Breadcrumb, Button, Col, Icon, Layout, PageHeader, Row, Switch, Table, Tag, Tooltip } from 'antd';
import axios from 'axios';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Constant } from '../../config';
import { GatewayColor, GatewayName } from '../../config/gateway';
import { fetchMenuAction } from '../../store/actions/leftSideMenu';
import MyModal from '../Modal';
import GatewayCountryForm from './form';
import SearchForm from './search-form';

const ButtonGroup = Button.Group;
const { Content } = Layout;

class GatewayCountry extends Component {
  state = {
    loading: false,
    dataSource: [],
    flagStatusToggle: {},
    current_data: {
      region_code: undefined,
      member_id: 0,
      gateway: [],
    },
    flagCreateOrUpdateForm: true, // true: created, false: updated
    visibleFormModal: false,
    countryList: [],
    gatewayList: [],
    currentCountryAbbr: "",
    currentPage: 1,
    currentSearch: "",
    limit: 20,
    totalRows: 0,
  };

  columns = [
    {
      title: 'Country',
      dataIndex: 'country_name',
      render: (text) => {
        if (text === 'NONE') text = 'Default';

        return <span style={{ fontWeight: 'bold' }}>{text}</span>;
      },
      align: 'center',
    },
    {
      title: 'Gateway List',
      dataIndex: 'gateway',
      render: (text, record) => {
        let rtn = [];
        for (let i = 0; i < record.gateway.length; i++) {
          const v = record.gateway[i];

          rtn.push(
            <Tag key={i} color={GatewayColor(v.gateway_detail.key_name)}>
              {GatewayName(v.gateway_detail.key_name)}
            </Tag>,
          );
        }

        return rtn;
      },
    },
    {
      title: 'Enabled / Disable',
      dataIndex: 'status',
      render: (status, record) => {
        if (!record.region_code || record.region_code === 'NONE') return '';

        const checked = status === 'enabled';

        return (
          <Switch
            checkedChildren={<Icon type="check" />}
            unCheckedChildren={<Icon type="close" />}
            checked={checked}
            onChange={(e) => this.toggleStatus(e, record.region_code, record.member_id)}
          />
        );
      },
      align: 'center',
    },
    {
      title: 'Action',
      dataIndex: 'id',
      render: (text, record) => {
        if (!record.region_code) return '';

        return (
          <ButtonGroup>
            <Tooltip placement="top" title="แก้ไข">
              <Button
                icon="edit"
                onClick={() =>
                  this._edit(record.region_code, record.member_id, record.gateway)
                }
              />
            </Tooltip>
            {record.region_code !== 'NONE' ? (
              <Tooltip placement="top" title="ลบ">
                <Button
                  type="danger"
                  icon="delete"
                  onClick={() => this._delete(record.region_code, record.member_id)}
                />
              </Tooltip>
            ) : null}
          </ButtonGroup>
        );
      },
    },
  ];

  componentWillMount() {
    this.props.fetchMenuAction('gateway-country', 'gateway-country');
    this.setState({ loading: true });
  }

  async componentDidMount() {
    const dataSource = await this._getList(
      this.state.currentPage,
      this.state.limit,
      this.state.currentSearch,
    );
    const countryList = await this._getCountryList();
    const gatewayList = await this._getGatewayList();

    this.setState({
      loading: false,
      dataSource,
      countryList,
      gatewayList,
    });
  }

  toggleStatus = (f, region_code = '', member_id = 0) => {
    if (!region_code) return;
    if (region_code === 'NONE' && member_id === 0) {
      window.location.reload();
      return;
    }

    let textConfirm = 'ปิดการใช้งาน';
    let url = Constant.GATEWAY_COUNTRY_API_DISABLE_API;
    if (f) {
      textConfirm = 'เปิดการใช้งาน';
      url = Constant.GATEWAY_COUNTRY_API_ENABLE_API;
    }

    MyModal.confirm(
      `ยืนยัน ${textConfirm} ใช่หรือไม่ ?`,
      '',
      async (isConfirm) => {
        if (!isConfirm) {
          return;
        }

        this.setState({ loading: true });

        try {
          await axios({
            url: url.replace('[id]', 0),
            data: { region_code, member_id },
            method: 'PUT',
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
              'Content-Type': 'application/json',
            },
          });

          const dataSourceUpdated = await this._getList(this.state.currentPage, this.state.limit, this.state.currentCountryAbbr);

          MyModal.success(`${textConfirm} สำเร็จ`, '', () => {
            this.setState({ 
              dataSource: dataSourceUpdated,
              loading: false
            });
          });

          // let tmp = this.state.flagStatusToggle;
          // tmp[region_code] = f;
          // this.setState({ flagStatusToggle: tmp, loading: false });
          
        } catch (e) {
          console.log(e);
          MyModal.error('เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง');
          this.setState({ loading: false });
        }
      },
      'ยืนยัน',
      'ยกเลิก',
    );
  };

  changePage = async (page, limit) => {
    this.setState({ 
      loading: true,
      currentPage: page,
      limit,
    });

    const dataSource = await this._getList(page, limit, this.state.currentCountryAbbr);

    this.setState({
      dataSource,
      loading: false,
    });
  };

  setFlagStatusToggle = (d) => {
    let rtn = {};
    for (let i = 0; i < d.length; i++) {
      rtn[d[i].region_code] = d[i].status === 'enabled';
    }

    return rtn;
  };

  formHandleSubmit = () => {
    const { form } = this.formRef.props;

    form.validateFields(async (err, values) => {
      if (err) return;

      MyModal.confirm(
        'ยืนยันบันทึกข้อมูล ใช่หรือไม่',
        '',
        async (f) => {
          if (!f) return;

          if (this.state.flagCreateOrUpdateForm)
            this.setState({ loading: true, currentPage: 1, currentCountryAbbr: "" });
          else this.setState({ loading: true });

          let opt = {
            url: Constant.GATEWAY_COUNTRY_API,
            method: this.state.flagCreateOrUpdateForm ? 'POST' : 'PUT',
            data: values,
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
              'Content-Type': 'application/json',
            },
          };
          let resp;
          let modeTxt = this.state.flagCreateOrUpdateForm ? 'เพิ่ม' : 'แก้ไข';
          let eMsg = `เกิดข้อผิดพลาด ไม่สามารถ${modeTxt}ข้อมูลได้ กรุณาลองใหม่อีกครั้ง`;
          let eFlag = false;
          let eMsgDetail = '';

          try {
            resp = await axios(opt);
          } catch (e) {
            resp = e.response;
          }

          if (!resp.data) {
            eFlag = true;
          } else if (resp.data.error) {
            eFlag = true;
            let e = resp.data.error;
            eMsgDetail = `[${e.code}] ${e.name}`;
          }

          if (eFlag) {
            MyModal.error(eMsg, eMsgDetail, () => {
              window.location.reload();
            });
            return;
          }

          if (this.state.flagCreateOrUpdateForm) form.resetFields();

          MyModal.success(`${modeTxt}ข้อมูลสำเร็จ`, '', async () => {
            let currentPage = this.state.currentPage;
            let currentCountryAbbr = this.state.currentCountryAbbr;
            if (this.state.flagCreateOrUpdateForm) {
              currentPage = 1;
              currentCountryAbbr = "";
            }

            const dataSource = await this._getList(currentPage, this.state.limit, currentCountryAbbr);

            this.setState({loading: false, visibleFormModal: false, dataSource });
          });
        },
        'ยืนยัน',
        'ยกเลิก',
      );
    });
  };

  formHandleCancel = () => {
    this.setState({
      visibleFormModal: false,
      current_data: {
        region_code: undefined,
        member_id: 0,
        gateway: [],
      },
    });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  _getList = async (page = 1, limit = 10, search = '') => {
    const url =
      Constant.GATEWAY_COUNTRY_API +
      '?page=' +
      page +
      '&limit=' +
      limit +
      '&search=' +
      search;
    const opt = {
      url,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    const totalRows = resp.data.total_rows || 0;
    this.setState({ totalRows });

    const d = resp.data.data;
    let rtn = [];

    if (d.length < 1) return [];

    let index = 0;
    let groupRegionCode = d[0].region_code;
    rtn.push({
      key: index + 1,
      country_name: d[0].country_detail ? d[0].country_detail.name : d[0].region_code,
      region_code: d[0].region_code,
      gateway: [],
      status: d[0].status,
      id: d[0].id,
      member_id: d[0].member_id,
    });

    for (let i = 0; i < d.length; i++) {
      let v = d[i];

      if (groupRegionCode !== v.region_code) {
        groupRegionCode = v.region_code;
        index++;

        rtn.push({
          key: index + 1,
          country_name: v.country_detail ? v.country_detail.name : v.region_code,
          region_code: v.region_code,
          gateway: [],
          status: v.status,
          id: v.id,
          member_id: v.member_id,
        });
      }

      rtn[index].gateway.push(v);
    }

    return rtn;
  };

  _getCountryList = async () => {
    const opt = {
      url: `${Constant.COUNTRY_API}?limit=0`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    let rtn = [{ region_code: 'NONE', name: 'Default' }];
    resp.data.data.map((v) => rtn.push(v));

    return rtn;
  };

  _getGatewayList = async () => {
    const opt = {
      url: `${Constant.GATEWAY_API}?limit=0`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data.data;
  };

  _create = () => {
    this.setState({
      current_data: {
        region_code: undefined,
        member_id: 0,
        gateway: [],
      },
      flagCreateOrUpdateForm: true,
      visibleFormModal: true,
    });
  };

  _edit = (region_code = '', member_id = 0, gateway = []) => {
    if (!region_code) return;

    let tmp = [];
    for (let i = 0; i < gateway.length; i++) {
      tmp.push(gateway[i].gateway_id);
    }

    this.setState({
      current_data: {
        region_code,
        member_id,
        gateway: tmp,
      },
      flagCreateOrUpdateForm: false,
      visibleFormModal: true,
    });
  };

  _delete = (region_code = '', member_id = 0) => {
    if (!region_code) return;
    if (region_code === 'NONE' && member_id === 0) {
      window.location.reload();
      return;
    }

    MyModal.confirm(
      `คุณต้องการลบรายการนี้ ใช่หรือไม่ ?`,
      '',
      async (isConfirm) => {
        if (!isConfirm) {
          return;
        }

        this.setState({ loading: true, currentPage: 1, currentCountryAbbr: "" });

        try {
          await axios({
            url: Constant.GATEWAY_COUNTRY_API_DELETED_API.replace('[id]', 0),
            data: { region_code, member_id },
            method: 'PUT',
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
              'Content-Type': 'application/json',
            },
          });

          MyModal.success('ลบรายการสำเร็จ');
          const dataSource = await this._getList(1, this.state.limit, "");

          this.setState({
            dataSource,
            flagStatusToggle: this.setFlagStatusToggle(dataSource),
            loading: false,
          });
        } catch (e) {
          console.log(e);
          MyModal.error('เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง');
          this.setState({ loading: false });
        }
      },
      'ยืนยัน',
      'ยกเลิก',
    );
  };

  mySearch = (fd) => {
    fd.validateFields(async (err, values) => {
      if (err) return;

      const currentCountryAbbr = values.country_abbr || "";
      const currentPage = 1;

      this.setState({ 
        currentCountryAbbr,
        loading: true,
        currentPage,
      });
      const dataSource = await this._getList(currentPage, this.state.limit, currentCountryAbbr);
      this.setState({ dataSource, loading: false });
    });
  }

  resetSearch = async () => {
    this.setState({ currentCountryAbbr: "", loading: true, currentPage: 1 });
    const dataSource = await this._getList(1, this.state.limit, "");
    this.setState({ dataSource, loading: false });
  }

  render() {
    const propsTable = {
      className: 'my-table customer-table',
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: (record) => record.id,
      pagination: {
        pageSize: this.state.limit,
        total: this.state.totalRows,
        current: this.state.currentPage,
        onChange: this.changePage,
        size: 'small',
      },
      scroll: { x: "max-content" },
    };
    // let propsTableForMobile = Object.assign({}, propsTable)
    // propsTableForMobile.className = "my-table-mobile"
    // propsTableForMobile.columns = this.columnsMobile

    return (
      <Layout>
        <Breadcrumb className="breadcrumb">
          <Breadcrumb.Item>Gateway Route Configuration</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader
          style={{
            backgroundColor: "#f0f2f5",
          }}
          title={<h2 style={{ fontWeight: "bold" }}>Gateway Route Configuration</h2>}
        />

        <Layout className="my-layout">
          <Content className="main-container">
            <div className="main-container-inner pb-0">
              <Row type="flex" justify="end">
                <Col span={12}>
                  <Button type="primary" onClick={() => this._create()} className='mt-4'>
                    <Icon type="plus" />
                    Add Gateway Route
                  </Button>
                </Col>
                <Col span={12} className='text-right'>
                  <SearchForm
                    countryList={this.state.countryList}
                    fn={this.mySearch}
                    fnReset={this.resetSearch}
                  />
                </Col>
              </Row>
            </div>
            {/* <Row className="utility-bar">
              <Col span={6}>
                <Button icon="plus-circle" onClick={() => this._create()}>
                  เพิ่ม
                </Button>
              </Col>
              <Col span={18}>
                <SearchForm
                  countryList={this.state.countryList}
                  fn={this.mySearch}
                  fnReset={this.resetSearch}
                />
              </Col>
            </Row>
            <Row className="utility-bar-mobile">
              <Button icon="plus-circle" onClick={() => this._create()}>
                เพิ่ม
              </Button>
            </Row>
            <Row className="utility-bar-mobile"></Row> */}
            <Table {...propsTable} />
            {/* <Table {...propsTableForMobile} /> */}
          </Content>
        </Layout>
        {/* <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล..."> */}
          
        {/* </Spin> */}
        <GatewayCountryForm
          wrappedComponentRef={this.saveFormRef}
          visible={this.state.visibleFormModal}
          onCancel={this.formHandleCancel}
          onCreate={this.formHandleSubmit}
          data={this.state.current_data}
          flagCreateOrUpdateForm={this.state.flagCreateOrUpdateForm}
          countryList={this.state.countryList}
          gatewayList={this.state.gatewayList}
          loading={this.state.loading}
        />
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headerBarStore: state.headerBar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GatewayCountry);



// WEBPACK FOOTER //
// ./src/containers/GatewayCountry/index.js